export const APP_INFO = {
  Version: '2.7.2',
  ContactEmailUrl: 'mailto:support@networcx.io',
  ContactEmail: 'support@networcx.io',
  AppDeveloper: 'Networcx AG',
  DeveloperWebsite: 'https://networcx.io',
};
